import React from 'react';
export function Guarantee() {
  return <div className="bg-[#0c0c0c] py-16 px-6" data-id="element-189">
      <div className="max-w-[960px] mx-auto" data-id="element-190">
        <div className="bg-brand-green/5 border-2 border-brand-green/20 rounded-2xl py-11 px-9 text-center max-w-[600px] mx-auto" data-id="element-191">
          <div className="w-20 h-20 rounded-full bg-brand-green text-white font-display flex flex-col items-center justify-center mx-auto mb-5 leading-none" data-id="element-192">
            <span className="text-[28px] font-bold" data-id="element-193">7</span>
            <span className="text-[11px] font-semibold tracking-[1px]" data-id="element-194">
              DÍAS
            </span>
          </div>

          <h2 className="font-display text-[26px] text-white mb-3.5 uppercase" data-id="element-195">
            Garantía Incondicional de 7 Días
          </h2>

          <div className="flex flex-col gap-2" data-id="element-196">
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-197">
              <span className="text-brand-green text-[16px]" data-id="element-198">✦</span> Devolución
              del 100%
            </div>
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-199">
              <span className="text-brand-green text-[16px]" data-id="element-200">✦</span> Sin
              formularios
            </div>
            <div className="flex items-center justify-center gap-2 text-[14px] text-white/80" data-id="element-201">
              <span className="text-brand-green text-[16px]" data-id="element-202">✦</span> Sin drama
            </div>
          </div>
        </div>
      </div>
    </div>;
}